import ParsedFroalaHtml from './ParsedFroalaHtml';

export default ParsedFroalaHtml;
